<div class="bookmarked-recipes-container">
  <app-loading *ngIf="showLoading"></app-loading>
  <div class="bookmarked-recipes-nav-bar">
    <div class="bookmarked-recipes-nav-bar-title">نشان شده‌ها</div>
    <div class="bookmarked-recipes-back" (click)="back()">
      <img src="assets/general/back-blue.svg" />
    </div>
  </div>
  <div *ngIf="dataIsReady" class="bookmarked-recipes-holder">
    <div
      *ngFor="let b of bookmarks; let last = last"
      class="recipeBox"
      [ngStyle]="{ 'margin-bottom': last ? '16px' : '0' }"
    >
      <img
        class="recipe-box-image"
        src="{{ b.recipe.imagePath }}"
        (click)="showDetail(b.recipe._id)"
      />
      <div class="recipe-box-food" (click)="showDetail(b.recipe._id)">
        {{ b.recipe.food.name }}
      </div>
      <div class="recipe-box-bookmark" (click)="bookmark(b)">
        <img src="assets/recipe/bookmarked.png" />
      </div>
    </div>
  </div>
  <div *ngIf="bookmarks.length === 0 && dataIsReady" class="no-recipes">
    دستور پختی نشان نکرده‌اید
  </div>
</div>
